import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ProtectedPageView from "../views/ProtectedPageView.vue";
import DashboardView from "../views/DashboardView.vue";
import NoAccessView from "../views/NoAccessView.vue"; // Import NoAccessView

const routes = [
  { path: "/", name: "HomeView", component: HomeView },
  {
    path: "/protected",
    name: "ProtectedPageView",
    component: ProtectedPageView,
  },
  {
    path: "/dashboard",
    name: "DashboardView",
    component: DashboardView,
    props: true,
  },
  {
    path: "/no-access", // Add NoAccessView route
    name: "NoAccessView",
    component: NoAccessView,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  }, // Redirect unknown routes to home
];

const router = createRouter({
  history: createWebHistory("/app/"), // Set base URL to match the subdirectory
  routes,
});

export default router;
